(() => {
  'use strict';

  const qs = (selector, context = document) => context.querySelector(selector);
  const qsa = (selector, context = document) => [...context.querySelectorAll(selector)];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
  }[character]));

  const uniqueFallbackDataUri = (title = 'MonsterLab', key = '', context = 'Produit MonsterLab') => {
    const safeTitle = String(title).replace(/[<>&"']/g, '').slice(0, 52);
    const safeContext = String(context).replace(/[<>&"']/g, '').slice(0, 30);
    const source = `${safeTitle}|${key}|${safeContext}`;
    let hash = 0;
    for (let i = 0; i < source.length; i += 1) hash = ((hash << 5) - hash + source.charCodeAt(i)) | 0;
    const p1 = 170 + Math.abs(hash % 280);
    const p2 = 420 + Math.abs((hash >> 3) % 260);
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 1000" role="img" aria-label="${safeTitle}"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop stop-color="#050607"/><stop offset="1" stop-color="#10161d"/></linearGradient><radialGradient id="b"><stop stop-color="#0A5184" stop-opacity=".62"/><stop offset="1" stop-color="#0A5184" stop-opacity="0"/></radialGradient></defs><rect width="800" height="1000" fill="url(#g)"/><circle cx="${p1}" cy="${p2}" r="300" fill="url(#b)"/><g fill="none" stroke="#0A5184" stroke-opacity=".4" stroke-width="3"><path d="M-40 280 C180 170 520 390 850 210"/><path d="M-40 390 C190 250 510 520 850 330"/><path d="M-40 500 C210 360 500 650 850 450"/><path d="M-40 610 C230 480 490 760 850 570"/></g><rect x="50" y="50" width="700" height="900" rx="28" fill="none" stroke="#fff" stroke-opacity=".12"/><text x="64" y="120" fill="#fff" font-size="46" font-family="Arial,sans-serif" font-weight="800">ML</text><text x="64" y="162" fill="#0A5184" font-size="18" font-family="Arial,sans-serif" letter-spacing="6">MONSTERLAB</text><text x="64" y="770" fill="#0A5184" font-size="20" font-family="Arial,sans-serif">${safeContext.toUpperCase()}</text><text x="64" y="825" fill="#fff" font-size="30" font-family="Arial,sans-serif" font-weight="800">${safeTitle.toUpperCase()}</text><text x="64" y="910" fill="#bbc4cc" font-size="15" font-family="Arial,sans-serif">VISUEL UNIQUE — PHOTO PRODUIT À AJOUTER SI DISPONIBLE</text></svg>`;
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
  };
  const predictiveKnownImage = (title = '') => {
    const t = String(title).toLowerCase();
    const assets = window.MonsterLabPredictiveKnownAssets || {};
    if (t.includes('compression performance')) return assets.compression || '';
    if (t.includes('débardeur evolution') || t.includes('debardeur evolution')) return assets.tank || '';
    if (t.includes('oversize human performance')) return assets.oversize || '';
    if (t.includes('soft motion')) return assets.softMotion || '';
    if (t.includes('king mass') || t.includes('rc gainer') || (t.includes('ronnie coleman') && t.includes('mass'))) return assets.rcKingMass || '';
    if ((t.includes('gold standard') || t.includes('optimum nutrition')) && t.includes('whey')) return assets.goldStandardWhey || '';
    if (t.includes('hand grip') || t.includes('palm grip') || t.includes('grip anti') || t.includes('gants anti-dérapants') || t.includes('gants anti-derapants')) return assets.handGrip || '';
    if (t.includes('miami') && t.includes('creatine')) return assets.miamiVibes || '';
    if (t.includes('biotech') && t.includes('180') && t.includes('creatine')) return assets.biotech180 || '';
    if (t.includes('biotechusa') && t.includes('creatine')) return assets.biotechUSA300 || '';
    if (t.includes('activlab') && t.includes('creatine')) return assets.activlabCreatine || '';
    if (t.includes('ostrovit') && t.includes('creatine')) return assets.ostrovit300 || '';
    if (t.includes('activlab') && t.includes('mass up')) return assets.activlabMass || '';
    if (t.includes('muscletech') && t.includes('mass tech')) return assets.muscletechMass || '';
    if (t.includes('magnesium') || t.includes('magnésium')) return assets.magnesium || '';
    if (t.includes('omega-3') || t.includes('oméga-3') || t.includes('omega 3')) return assets.omega3 || '';
    return '';
  };

  const applyThumbnailFallback = (image) => {
    if (!(image instanceof HTMLImageElement) || image.dataset.mlFallbackApplied === 'true') return;
    image.dataset.mlFallbackApplied = 'true';
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    const card = image.closest('[data-product-id], .cart-item, .predictive-result, .collection-hub-card');
    const key = card?.dataset.productId || card?.dataset.lineIndex || card?.dataset.collectionHandle || image.alt || '';
    const context = card?.dataset.visualContext || (card?.classList.contains('cart-item') ? 'Panier MonsterLab' : 'MonsterLab');
    image.src = uniqueFallbackDataUri(image.alt || 'MonsterLab', key, context);
    image.classList.add('ml-thumbnail--fallback', 'ml-thumbnail--unique-fallback');
  };

  // Capture image errors from Shopify CDN, deleted Files references, and dynamically injected results.
  document.addEventListener('error', (event) => {
    const image = event.target;
    if (image instanceof HTMLImageElement && (image.classList.contains('ml-thumbnail') || image.classList.contains('ml-resilient-image'))) {
      applyThumbnailFallback(image);
    }
  }, true);

  document.documentElement.classList.add('reveal-ready');

  /* Mobile navigation */
  const menu = qs('[data-mobile-menu]');
  const overlay = qs('[data-mobile-overlay]');
  const menuToggle = qs('[data-menu-toggle]');
  const closeButton = qs('[data-menu-close]');
  let lastFocusedElement = null;
  let lockedScrollY = 0;

  const setSubmenuState = (button, open) => {
    if (!button) return;
    const panelId = button.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    const group = button.closest('[data-mobile-nav-group]');
    if (!panel) return;

    button.setAttribute('aria-expanded', String(open));
    group?.classList.toggle('is-open', open);
    panel.hidden = !open;
    const icon = qs('.mobile-submenu-icon', button);
    if (icon) icon.textContent = open ? '−' : '+';
  };

  const lockPage = () => {
    lockedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${lockedScrollY}px`;
    document.body.style.width = '100%';
    document.body.classList.add('menu-open');
    document.documentElement.classList.add('menu-open');
  };

  const unlockPage = () => {
    document.body.classList.remove('menu-open');
    document.documentElement.classList.remove('menu-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
  };

  const closeMenu = ({ restoreFocus = true } = {}) => {
    if (!menu || menu.getAttribute('aria-hidden') === 'true') return;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    menuToggle?.setAttribute('aria-expanded', 'false');
    menuToggle?.setAttribute('aria-label', 'Ouvrir le menu');
    if (overlay) overlay.hidden = true;
    unlockPage();

    if (restoreFocus && lastFocusedElement instanceof HTMLElement) {
      lastFocusedElement.focus({ preventScroll: true });
    }
  };

  const openMenu = () => {
    if (!menu || menu.getAttribute('aria-hidden') === 'false') return;
    lastFocusedElement = document.activeElement;
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    menuToggle?.setAttribute('aria-expanded', 'true');
    menuToggle?.setAttribute('aria-label', 'Fermer le menu');
    if (overlay) overlay.hidden = false;
    lockPage();
    menu.focus({ preventScroll: true });
  };

  menuToggle?.addEventListener('click', () => {
    const open = menuToggle.getAttribute('aria-expanded') === 'true';
    open ? closeMenu() : openMenu();
  });
  closeButton?.addEventListener('click', () => closeMenu());
  overlay?.addEventListener('click', () => closeMenu());

  menu?.addEventListener('click', (event) => {
    const submenuButton = event.target.closest('[data-mobile-submenu-toggle]');
    if (submenuButton) {
      event.preventDefault();
      event.stopPropagation();
      const shouldOpen = submenuButton.getAttribute('aria-expanded') !== 'true';
      qsa('[data-mobile-submenu-toggle]', menu).forEach((otherButton) => {
        if (otherButton !== submenuButton) setSubmenuState(otherButton, false);
      });
      setSubmenuState(submenuButton, shouldOpen);
      return;
    }

    if (event.target.closest('a[href]')) closeMenu({ restoreFocus: false });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu?.classList.contains('is-open')) {
      event.preventDefault();
      closeMenu();
      return;
    }

    if (event.key !== 'Tab' || !menu?.classList.contains('is-open')) return;
    const focusable = qsa('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', menu)
      .filter((element) => !element.closest('[hidden]'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.matchMedia('(min-width: 821px)').addEventListener?.('change', (event) => {
    if (event.matches) closeMenu({ restoreFocus: false });
  });

  /* Search */
  const searchToggle = qs('[data-search-toggle]');
  const searchPanel = qs('[data-search-panel]');
  searchToggle?.addEventListener('click', () => {
    if (!searchPanel) return;
    searchPanel.hidden = !searchPanel.hidden;
    searchToggle.setAttribute('aria-expanded', String(!searchPanel.hidden));
    if (!searchPanel.hidden) qs('[data-search-input]', searchPanel)?.focus();
  });

  const searchInput = qs('[data-search-input]');
  const searchResults = qs('[data-predictive-results]');
  let searchTimer;
  let searchController;

  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchController?.abort();
    const query = searchInput.value.trim();
    if (!searchResults) return;
    if (query.length < 2) {
      searchResults.innerHTML = '';
      return;
    }

    searchTimer = setTimeout(async () => {
      searchController = new AbortController();
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`, { signal: searchController.signal });
        if (!response.ok) throw new Error('Predictive search request failed');
        const data = await response.json();
        const products = data.resources?.results?.products || [];
        searchResults.innerHTML = products.map((product, productIndex) => {
          const rawImage = predictiveKnownImage(product.title) || product.featured_image?.url || product.image || '';
          let imageUrl = rawImage;
          if (rawImage && /^https?:\/\//.test(rawImage)) {
            try {
              const url = new URL(rawImage);
              if (url.hostname.includes('cdn.shopify.com')) url.searchParams.set('width', '128');
              imageUrl = url.toString();
            } catch (_) { /* Keep original URL. */ }
          }
          if (!imageUrl) imageUrl = uniqueFallbackDataUri(product.title, product.id || product.handle || productIndex, 'Recherche MonsterLab');
          return `
          <a class="predictive-result predictive-result--${productIndex % 6}" href="${escapeHtml(product.url)}" data-product-id="${escapeHtml(product.id || product.handle || productIndex)}" data-visual-context="predictive-search">
            <img class="ml-thumbnail predictive-result-image" src="${escapeHtml(imageUrl)}" alt="${escapeHtml(product.title)}" width="64" height="64" loading="eager" decoding="async">
            <span>${escapeHtml(product.title)}</span>
            <strong>${escapeHtml(product.price || '')}</strong>
          </a>`;
        }).join('') || '<div class="predictive-result"><span>Aucun produit trouvé</span></div>';
      } catch (error) {
        if (error.name !== 'AbortError') searchResults.innerHTML = '';
      }
    }, 220);
  });

  /* Hero carousel */
  qsa('[data-hero-carousel]').forEach((hero) => {
    const slides = qsa('[data-slide]', hero);
    const dots = qsa('[data-dot]', hero);
    if (!slides.length) return;

    let index = 0;
    let timer;
    let visible = true;

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    };

    const auto = () => {
      clearInterval(timer);
      if (!reduceMotion.matches && visible) timer = setInterval(() => show(index + 1), 6500);
    };

    qs('[data-next]', hero)?.addEventListener('click', () => { show(index + 1); auto(); });
    qs('[data-prev]', hero)?.addEventListener('click', () => { show(index - 1); auto(); });
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => { show(dotIndex); auto(); }));

    let touchStartX = 0;
    hero.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.clientX || 0; }, { passive: true });
    hero.addEventListener('touchend', (event) => {
      const deltaX = (event.changedTouches[0]?.clientX || 0) - touchStartX;
      if (Math.abs(deltaX) < 45) return;
      show(index + (deltaX < 0 ? 1 : -1));
      auto();
    }, { passive: true });
    hero.addEventListener('mouseenter', () => clearInterval(timer));
    hero.addEventListener('mouseleave', auto);
    hero.addEventListener('focusin', () => clearInterval(timer));
    hero.addEventListener('focusout', auto);

    hero.addEventListener('pointermove', (event) => {
      if (window.innerWidth < 900 || reduceMotion.matches) return;
      const rect = hero.getBoundingClientRect();
      hero.style.setProperty('--px', `${(event.clientX - rect.left - rect.width / 2) * 0.018}px`);
      hero.style.setProperty('--py', `${(event.clientY - rect.top - rect.height / 2) * 0.018}px`);
    });
    hero.addEventListener('pointerleave', () => {
      hero.style.setProperty('--px', '0px');
      hero.style.setProperty('--py', '0px');
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        auto();
      }, { threshold: 0.08 }).observe(hero);
    }

    show(0);
    auto();
  });

  /* Reveal animations */
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }), { threshold: 0.08, rootMargin: '0px 0px -4% 0px' })
    : null;

  qsa('[data-reveal-section]').forEach((element) => observer ? observer.observe(element) : element.classList.add('is-visible'));

  const counterObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const element = entry.target;
        const end = Number(element.dataset.counter || 0);
        if (reduceMotion.matches) {
          element.textContent = end + (end === 100 ? '%' : '');
        } else {
          let start = 0;
          const step = Math.max(1, Math.ceil(end / 45));
          const run = () => {
            start = Math.min(end, start + step);
            element.textContent = start + (end === 100 ? '%' : '');
            if (start < end) requestAnimationFrame(run);
          };
          run();
        }
        counterObserver.unobserve(element);
      }), { threshold: 0.6 })
    : null;

  qsa('[data-counter]').forEach((element) => counterObserver ? counterObserver.observe(element) : element.textContent = element.dataset.counter);

  /* Product and collection interactions */
  qsa('[data-media-target]').forEach((button) => button.addEventListener('click', () => {
    const gallery = button.closest('[data-product-gallery]');
    if (!gallery) return;
    qsa('.product-media-item', gallery).forEach((media) => media.classList.toggle('is-active', media.dataset.mediaId === button.dataset.mediaTarget));
    qsa('.product-thumb', gallery).forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
  }));

  qsa('[data-qty-minus]').forEach((button) => button.addEventListener('click', () => {
    const input = button.parentElement?.querySelector('input');
    if (input) input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
  }));

  qsa('[data-qty-plus]').forEach((button) => button.addEventListener('click', () => {
    const input = button.parentElement?.querySelector('input');
    if (input) input.value = Number(input.value || 1) + 1;
  }));

  qs('[data-scroll-product-form]')?.addEventListener('click', () => qs('[data-product-form]')?.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' }));

  const filterButton = qs('[data-filter-toggle]');
  filterButton?.addEventListener('click', () => {
    const filters = qs('[data-filters]');
    if (!filters) return;
    const open = filters.classList.toggle('is-open');
    filterButton.setAttribute('aria-expanded', String(open));
  });

  qsa('product-recommendations').forEach(async (element) => {
    try {
      const html = await fetch(element.dataset.url).then((response) => response.text());
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const fresh = documentFragment.querySelector('product-recommendations');
      if (fresh?.innerHTML.trim()) element.innerHTML = fresh.innerHTML;
    } catch (error) {
      /* Keep the page functional when recommendations are unavailable. */
    }
  });

  /* Smooth same-page anchors. Cross-page anchors keep native navigation. */
  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a[href^="#"]');
    if (!anchor) return;
    const id = anchor.getAttribute('href');
    if (!id || id === '#') return;
    const target = qs(id);
    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
  });

  /* Men Collection homepage carousel — v3.6.0 */
  qsa('[data-men-carousel]').forEach((carousel) => {
    const slides = qsa('[data-men-slide]', carousel);
    const dots = qsa('[data-men-dot]', carousel);
    const prev = qs('[data-men-prev]', carousel);
    const next = qs('[data-men-next]', carousel);
    if (slides.length < 2) return;

    let index = 0;
    let timer = null;
    let visible = true;
    let pointerStartX = null;

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.tabIndex = active ? 0 : -1;
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (!reduceMotion.matches && visible) timer = window.setInterval(() => show(index + 1), 5600);
    };

    prev?.addEventListener('click', () => { show(index - 1); start(); });
    next?.addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => { show(dotIndex); start(); }));

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); start(); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); start(); }
    });
    carousel.addEventListener('pointerdown', (event) => { pointerStartX = event.clientX; });
    carousel.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const delta = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(delta) < 45) return;
      show(index + (delta < 0 ? 1 : -1));
      start();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        if (visible) start(); else stop();
      }, { threshold: 0.12 }).observe(carousel);
    }

    show(0);
    start();
  });

})();
